import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-checkbox', {
    display: 'inline-block',
    verticalAlign: 'top',
    cursor: 'pointer',
    width: '15px',
    height: '15px',
    outline: 0,
    color: applyColor(DesignTokens.color.font.default.default, '#2e2e2e'),
    backgroundSize: '15px 15px',
    backgroundPosition: 'left top',
    backgroundRepeat: 'no-repeat',
    backgroundImage: 'url(img/checkbox_empty_normal.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-checkbox:hover, .tb-checkbox:focus', {
    backgroundImage: 'url(img/checkbox_empty_hover.svg?1_0_9606_yabs0uv7t1h)',
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-checkbox.tb-disabled', {
    backgroundImage: 'url(img/checkbox_empty_disabled.svg?1_0_9606_yabs0uv7t1h)',
    cursor: 'default',
    color: applyColor(DesignTokens.color.font.default.disabled, '#c9c9c9'),
});

cssRule('.tb-checkbox.tb-checked', {
    backgroundImage: 'url(img/checkbox_selected_normal.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-checkbox.tb-checked:hover, .tb-checkbox.tb-checked:focus', {
    backgroundImage: 'url(img/checkbox_selected_hover.svg?1_0_9606_yabs0uv7t1h)',
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-checkbox.tb-checked.tb-disabled', {
    backgroundImage: 'url(img/checkbox_selected_disabled.svg?1_0_9606_yabs0uv7t1h)',
    cursor: 'default',
    color: applyColor(DesignTokens.color.font.default.disabled, '#c9c9c9'),
});

cssRule('.tb-checkbox.tb-mixed', {
    backgroundImage: 'url(img/checkbox_mixed_normal.svg?1_0_9606_yabs0uv7t1h)',
});

cssRule('.tb-checkbox.tb-mixed:hover, .tb-checkbox.tb-mixed:focus', {
    backgroundImage: 'url(img/checkbox_mixed_hover.svg?1_0_9606_yabs0uv7t1h)',
    color: applyColor(DesignTokens.color.font.default.default, '#333'),
});

cssRule('.tb-checkbox.tb-mixed.tb-disabled', {
    backgroundImage: 'url(img/checkbox_mixed_disabled.svg?1_0_9606_yabs0uv7t1h)',
    cursor: 'default',
    color: applyColor(DesignTokens.color.font.default.disabled, '#c9c9c9'),
});

cssRule('.tb-checkbox.tb-with-label', {
    width: 'auto',
    height: 'auto',
    paddingLeft: '21px',
    lineHeight: '15px',
});

cssRule('.tb-checkbox-site-grid-cell', {
    display: 'block',
    marginTop: '11px',
    textAlign: 'center',
});

cssRule('.taller-rows .tb-checkbox-cell', {
    width: '15px',
    height: '15px',
    paddingTop: '14px',
    paddingLeft: '14px',
    paddingBottom: '15px',
    paddingRight: '15px',
});

cssRule('.taller-rows .tb-react-dg-hcell', {
    height: '44px',
    lineHeight: '44px',
});

